import { TicketAvailability } from '../enums';

export const insuranceTicketTitleSuffix = '+ Ticket Insurance';

export const isTicketWithInsurance = (ticket) =>
  ticket && ticket.title && ticket.title.endsWith(insuranceTicketTitleSuffix);

/*
 * Returns the booking form path for a ticketId
 */
export const ticketBookingPath = (ticketId) => `/book/${ticketId}`;

// TODO(orange): remove duplication in graphql
export const getTicketAvailability = (ticket) => {
  return ticket.availability || ticket.availabilityType;
};

export const getTicketAvailabilityType = (ticket) =>
  getTicketAvailability(ticket)?.type;

export const charityEntryIsAvailable = (ticket) => {
  if (!ticket) {
    return false;
  }

  const availabilityType = getTicketAvailabilityType(ticket);

  return (
    [TicketAvailability.AVAILABLE, TicketAvailability.NOT_AVAILABLE].includes(
      availabilityType,
    ) && !ticket.bookingEnabled // jrans , why accept NOT_AVAILABLE?
  );
};

export const isEnabledTicket = (ticket) => ticket?.bookingEnabled;

export const isCharityTicket = (ticket) => {
  const details = ticket?.charityDetails;

  return details?.title?.length > 0 && details?.charityId?.length > 0;
};

export const isAvailableTicket = (ticket) => {
  if (isCharityTicket(ticket)) {
    return charityEntryIsAvailable(ticket);
  }

  return getTicketAvailabilityType(ticket) === TicketAvailability.AVAILABLE;
};

export const getAllTicketsForRace = (race) =>
  (race?.tickets?.tickets || []).filter((t) => t && !t.isDeleted);

export const getAllAvailableTicketsForRace = (race) => {
  return getAllTicketsForRace(race).filter(isAvailableTicket);
};

export const getCharityTicketsForRace = (race) => {
  return getAllAvailableTicketsForRace(race).filter(isCharityTicket);
};

export const getNonCharityTicketsForRace = (race) => {
  return getAllAvailableTicketsForRace(race).filter((t) => !isCharityTicket(t));
};

export const getAvailableEnabledNonCharityTicketsForRace = (race) => {
  return getNonCharityTicketsForRace(race).filter(isEnabledTicket);
};

export const [getAvailableCharityTickets, getAvailableNonCharityTickets] = [
  getCharityTicketsForRace,
  getNonCharityTicketsForRace,
].map((getAvailableRaceTickets) => (event) => {
  const availableTickets = [];

  if (event && event.races && event.races.races) {
    const races = event.races.races;
    races.forEach((race) => {
      const tickets = getAvailableRaceTickets(race);

      tickets.forEach((ticket) => availableTickets.push(ticket));
    });
  }
  return availableTickets;
});

export const getAvailableBookingEnabledNonCharityTickets = (event) => {
  return getAvailableNonCharityTickets(event).filter(isEnabledTicket);
};

export const getEnabledAvailableNonCharityTickets = getAvailableBookingEnabledNonCharityTickets;

export const getRaceIdWithAvailableCharityTickets = (event) => {
  if (event && event.races && event.races.races) {
    const racesWithTickets = event.races.races.filter((race) => {
      const charityTickets = getCharityTicketsForRace(race);

      return charityTickets.length > 0;
    });
    if (racesWithTickets && racesWithTickets.length > 0) {
      return racesWithTickets[0].id;
    }
  }
  return null;
};

export const getRaceIdWithAvailableNonCharityTickets = (event, enabledOnly) => {
  if (event && event.races && event.races.races) {
    const racesWithTickets = event.races.races.filter((race) => {
      const nonCharityTickets = enabledOnly
        ? getNonCharityTicketsForRace(race).filter(isEnabledTicket)
        : getNonCharityTicketsForRace(race);

      return nonCharityTickets.length > 0;
    });
    if (racesWithTickets.length > 0) {
      return racesWithTickets[0].id;
    }
  }
  return null;
};

export const getRaceOnEvent = (event, raceId) => {
  const races = event?.races?.races?.filter((race) => race.id === raceId);
  return races && races[0];
};

export const isTicketAvailable = (ticket) => {
  return (
    getTicketAvailabilityType(ticket) === TicketAvailability.AVAILABLE &&
    ticket.bookingEnabled
  );
};

export const getAvailableTicketsForRace = (race) => {
  return race?.tickets?.tickets?.filter(isTicketAvailable);
};

/*
 *  Returns flat map of all available tickets for passed event obj
 * and decorates it with race details
 */
export const getAvailableTicketsForEvent = (event) => {
  const tickets = [];
  const races = event?.races?.races;

  if (!races) return tickets;

  races.forEach((race) => {
    if (race?.tickets?.tickets?.length > 0) {
      const ticketsForRace = getAvailableTicketsForRace(race);
      if (ticketsForRace) {
        ticketsForRace.forEach((ticket) => {
          const ticketWithRace = { race, ...ticket };
          tickets.push(ticketWithRace);
        });
      }
    }
  });

  return tickets;
};

export const getSelectedTicket = (event, ticketId) => {
  const tickets = getAvailableTicketsForEvent(event);

  const selectedTicket =
    tickets &&
    tickets.filter((ticket) => {
      return ticket.id === ticketId;
    })[0];

  if (!selectedTicket) {
    return null;
  }
  return selectedTicket;
};

export const getRaceByTicketId = (races = [], ticketId) => {
  return races.find((race) => {
    return race?.tickets?.tickets?.find((ticket) => ticket.id === ticketId);
  });
};

export const getTicketsForSelectedRace = (race) =>
  getAvailableTicketsForRace(race) || [];

export const getRaceById = (races, raceId) => {
  return races.find((race) => race.id === raceId);
};
